<template>
  <!-- 待外发录入列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems glo_bgcMainColor" @click="addNotice()" v-permission="'admin:xitonggonggao:add'"
          >新建公告</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="delNotice()" v-permission="'admin:xitonggonggao:del'"
          >删除</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="sendNotice()" v-permission="'admin:xitonggonggao:publish'"
          >发布</el-button
        >
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <!-- 表格 -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <mytable
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="true"
      :isselection="true"
      :isShowMoreOperate="false"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
    >
    </mytable>
    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <myDialog
      diaWidth="1400px"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="isShowDialog = false"
      height-lock
      body-full
      @diaConfirmBtn="diaConfirm"
      @diaCancelBtn="isShowDialog = false"
    >
      <el-form
        :model="params"
        style="padding: 10px 20px"
        label-position="left"
        label-width="40px"
      >
        <el-form-item prop="title" label="标题">
          <el-input v-model="params.title" :disabled="!editable"></el-input>
        </el-form-item>
        <el-form-item prop="content" label="内容">
          <el-input
            type="textarea"
            rows="8"
            v-model="params.content"
            :disabled="!editable"
          ></el-input>
        </el-form-item>
      </el-form>
    </myDialog>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import mytable from "@/components/table/table.vue";
import myDialog from "@/components/Dialog.vue";
export default {
  mixins: [tableListNew, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    mytable,
    myDialog,
  },
  data() {
    return {
      pageGroupName: "sys_notice_list", //  页面标识
      reportFiledsNumber: "sys_notice_list", // 动态 条件、表头
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "editNotice", //当前页面的方法
          param: 1, //自定义参数标记
          permission:'admin:xitonggonggao:edit'
        },
        {
          name: "发布", //按钮名称
          methods: "sendNotice", //当前页面的方法
          param: 1, //自定义参数标记
          permission:'admin:xitonggonggao:publish'
        },
        {
          name: "详情",
          methods: "detail",
          param: 2,
          permission:'admin:xitonggonggao:detail'
        },
        {
          name: "删除",
          methods: "delNotice",
          param: 1,
          permission:'admin:xitonggonggao:del'
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      dialogTitle: "新建公告",
      Operatewidth: "200px", //操作列的列宽
      conditions: {
        languange: "zh-CN",
      },
      isShowDialog: false,
      params: {},
      immediate:true,
      editable:false
    };
  },
  mounted() {},
  watch: {},
  methods: {
    // 新增、 修改 、查看
    addNotice() {
      this.isShowDialog = true;
      this.dialogTitle = "新建公告";
      this.editable = true
    },
    editNotice(row) {
      this.isShowDialog = true;
      this.dialogTitle = "修改公告";
      this.params = {
        ...row,
      };
      this.editable = true
    },
    sendNotice(row) {
      if(!row && this.selectTableData.length === 0){
        this.$message.warning("请选择需要发布的公告")
      }
      let notices = []
      if(row){
        notices = [row]
      }else{
        notices = this.selectTableData
      }
      this.$confirm('确认要发布所选数据？').then(res=>{
        this.$API.sendSysNotice({
          sysNoticeIds: notices.map(item=>item.noticeId)
        }).then(re => {
          this.$message.success('发布成功')
          this.getData()
        })
      })
    },
    detail(row){
      this.isShowDialog = true;
      this.editable = false
      this.dialogTitle = "公告详情";
      this.params = {
        ...row,
      };
    },
    delNotice(row){
      if(!row && this.selectTableData.length === 0){
        this.$message.warning("请选择需要删除的公告")
      }
      let notices = []
      if(row){
        notices = [row]
      }else{
        notices = this.selectTableData
      }
      this.$confirm('是否确定要删除改公告').then(res => {
        this.$API.deleteSysNotice({
          sysNoticeIds: notices.map(item=>item.noticeId)
        }).then(re => {
          this.$message.success("删除公告")
          this.getData()
        })
      }).catch(err =>{

      })
    },
    diaConfirm() {
      if(!this.editable){
        this.isShowDialog = false
      }
      if (this.params.sysNoticeContentId) {
        this.submitEdit();
      } else {
        this.submitAdd();
      }
      this.editable = false
    },
    submitAdd() {
      this.$API
        .addSysNotice({
          contentReq: [
            {
              ...this.params,
              subtitle: this.params.title,
              languageCode: "zh-CN",
            },
          ],
        })
        .then((res) => {
          this.$message.success("保存成功");
          this.getData();
          this.isShowDialog = false;
          this.params = {}
        })
        .catch((err) => {});
    },
    submitEdit() {
      this.$API
        .updateSysNotice({
          contentReq: [
            {
              ...this.params,
              subtitle: this.params.title,
              languageCode: "zh-CN",
              sysNoticeContentId: this.params.sysNoticeContentId,
            },
          ],
        })
        .then((res) => {
          this.$message.success("保存成功");
          this.getData();
          this.isShowDialog = false;
          this.params = {}
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped lang="less">
</style>